import { useRecordStore, VhcItem } from 'features/vhc/model';
import { useVhcStore } from 'features/vhc/model/vhc-store';
import { groupNameMap } from 'features/vhc/pages/record/vhc/model/constants';
import { defaultVhcItems } from 'features/vhc/pages/record/vhc/model/utils';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';

export const getCorrectItem = (items: VhcItem[] | null, item: VhcItem) => {
  if (!items) return null;
  return items?.find((i) => i.id === item.id && i.type === item.type && i.group === item.group);
};

export const useVhcRecordModal = () => {
  const { recordModalIsOpen, recordModalData, setRecordModalIsOpen } = useVhcStore();
  const { items } = useRecordStore();

  const defaultValues: VhcItem | null | undefined = useMemo(() => {
    if (!recordModalData) return null;

    const serverItem = getCorrectItem(items, recordModalData.data);

    if (serverItem) return serverItem;

    const activeDefault = getCorrectItem(defaultVhcItems, recordModalData.data);

    if (!activeDefault) {
      return recordModalData.data;
    }

    return { ...activeDefault } as VhcItem;
  }, [recordModalData, items]);

  const recordFormState = useForm<VhcItem>({
    defaultValues: defaultValues ?? {}
  });

  useEffect(() => {
    if (defaultValues) {
      recordFormState.reset(defaultValues);
    }
  }, [defaultValues]);

  const handleClose = () => {
    setRecordModalIsOpen(null, false);
  };

  const groupName = useMemo(() => {
    if (recordModalData?.data.group === undefined) return null;

    return groupNameMap[recordModalData.data.group];
  }, [recordModalData?.data.group]);

  return { recordModalIsOpen, recordModalData, recordFormState, handleClose, groupName };
};
